import { BitfStorage } from '@bitf/core/models/bitf-storage.model';

// NOTE: default values must be defined in the StorageService, not in the model
// (otherwise the default here will override the super Object.assign())
export class Storage extends BitfStorage {
  canAccess?: string;

  constructor(storageData: Partial<Storage>) {
    super(storageData);
  }
}
